import { RootState } from "@/store/redux/store";
import Toast from "../../../../shared/components/Tosts/Toast";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setToast } from "../../store/mapScreenSlce";
import styled from "styled-components";
import LoaderCircle from "../loaders/LoaderCircle";

const ToastMap = () => {
    const toast = useSelector((state: RootState) => state.mapScreen.toast);
    const dispatch = useDispatch();
    return (
        <Toast
            visible={toast.visible}
            setVisible={(a) => dispatch(setToast({ text: '', type: 'loading', visible: false }))}
            isControled={true}
        >
            <Container>
                {toast?.type === 'loading' &&
                    <LoaderCircle />}
                <Text>{toast.text}</Text>
            </Container>
        </Toast>
    )
}

export default ToastMap;

const Container = styled.div`
display: flex;
flex-direction: row;
align-items: center;
gap: 10px;
`
const Text = styled.span`
font-size: 16px;
font-weight: 500;
font-color: gray;
`